module.exports = __webpack_public_path__ + "static/kalendit-logo-6c6c11aa882b082b188fb7daaf72f475.svg";